import styled from "styled-components";
import { Box, darken, lighten } from "@mui/material";
import { TemplateColorObject } from "../../../../../InvitationColorMatrix";

export const RingsEntranceWrapper = styled(Box)<{ colormatrix: TemplateColorObject }>`
	position: absolute;
	z-index: 3;
	width: 100%;
	max-width: 430px;
	height: 100vh;
	overflow: hidden;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	gap: 60px;
	transition: opacity 1.2s ease-in-out 1.4s;
	box-sizing: border-box;
	background: ${props => props.colormatrix.entrance.background};

	&.show {
		opacity: 1;
		cursor: pointer;
	}

	&.hide {
		opacity: 0;
		z-index: -1;
		cursor: unset;
	}

	&.preview {
		position: relative;
		width: 100%;
		max-width: 320px;
		height: 600px;
		gap: 30px;
		padding: 20px 0;
		border-radius: 16px;
		overflow: hidden;
		margin: 0 auto;
		cursor: default;
	}

	.bg_flowers {
		position: absolute;
		inset: 0;
		z-index: 0;
		pointer-events: none;
		opacity: 0;
		animation: flowers_reveal 0.4s ease-in 0.4s forwards;
	}

	.flower {
		position: absolute;
		width: 50px;
		height: 50px;
		transform-origin: 50% 50%;
		will-change: transform;
		backface-visibility: hidden;
		animation-fill-mode: backwards;
	}

	.flower_1 {
		top: 35%;
		left: 5%;
		animation: flower_sway 7s ease-in-out infinite;
	}

	.flower_2 {
		top: 12%;
		right: 10%;
		width: 40px;
		height: 40px;
		animation: flower_sway 5.5s ease-in-out 0.6s infinite;
	}

	.flower_3 {
		top: 5%;
		left: 35%;
		width: 44px;
		height: 44px;
		animation: flower_sway 6.5s ease-in-out 1.1s infinite;
	}

	.flower_4 {
		top: 4%;
		right: 20%;
		animation: flower_sway 7.5s ease-in-out 0.3s infinite;
	}

	.flower .petal {
		position: absolute;
		top: 50%;
		left: 50%;
		width: 14px;
		height: 22px;
		margin-top: -11px;
		margin-left: -7px;
		border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%;
		background: ${props => props.colormatrix.main};
		opacity: 0.55;
	}

	.flower .petal:nth-child(1) {
		transform: rotate(0deg) translateY(-15px);
	}

	.flower .petal:nth-child(2) {
		transform: rotate(60deg) translateY(-15px);
	}

	.flower .petal:nth-child(3) {
		transform: rotate(120deg) translateY(-15px);
	}

	.flower .petal:nth-child(4) {
		transform: rotate(180deg) translateY(-15px);
	}

	.flower .petal:nth-child(5) {
		transform: rotate(240deg) translateY(-15px);
	}

	.flower .petal:nth-child(6) {
		transform: rotate(300deg) translateY(-15px);
	}

	.flower_2 .petal,
	.flower_4 .petal {
		background: ${props => props.colormatrix.footer};
	}

	.flower .center {
		position: absolute;
		top: 50%;
		left: 50%;
		width: 10px;
		height: 10px;
		margin: -5px;
		border-radius: 50%;
		background: ${props => props.colormatrix.entrance.envelope_background};
		opacity: 0.85;
		z-index: 1;
	}

	.couples_banner {
		position: relative;
		max-width: 300px;
		padding: 25px;
		background: linear-gradient(160deg, #fffaf0 0%, #f5e9d3 100%);
		box-shadow: inset 0 0 18px rgba(0, 0, 0, 0.06);
		filter: drop-shadow(0 8px 10px rgba(0, 0, 0, 0.3));
		transform: rotate(-1.4deg);
		clip-path: polygon(
			0% 5%,
			8% 0%,
			17% 5%,
			25% 0%,
			33% 5%,
			42% 0%,
			50% 5%,
			58% 0%,
			67% 5%,
			75% 0%,
			83% 5%,
			92% 0%,
			100% 5%,
			100% 95%,
			92% 100%,
			83% 95%,
			75% 100%,
			67% 95%,
			58% 100%,
			50% 95%,
			42% 100%,
			33% 95%,
			25% 100%,
			17% 95%,
			8% 100%,
			0% 95%
		);

		p {
			text-align: center;
			color: #3b4049;
		}

		.wedding_of {
			font-family: var(--roboto), sans-serif;
			font-size: 18px;
		}

		.couples {
			font-family: var(--inriaSerif), sans-serif;
			font-size: 24px;
		}
	}

	.couples_banner .wedding_of {
		animation: rings_name_drop 0.9s ease-out 0.2s backwards;
	}

	.couples_banner .groom {
		animation: rings_name_from_start 1s cubic-bezier(0.22, 1, 0.36, 1) 0.5s backwards;
	}

	.couples_banner .and {
		animation: rings_name_pop 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) 0.8s backwards;
	}

	.couples_banner .bride {
		animation: rings_name_from_end 1s cubic-bezier(0.22, 1, 0.36, 1) 1.1s backwards;
	}

	&.hide .couples_banner {
		animation: rings_names_glow 1.4s ease-in-out;
	}

	.rings_wrapper {
		position: relative;
		width: 220px;
		height: 120px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.ring {
		position: absolute;
		width: 90px;
		height: 90px;
		border-radius: 50%;
		box-sizing: border-box;
		box-shadow:
			inset -4px -4px 6px rgba(0, 0, 0, 0.25),
			inset 4px 4px 6px rgba(255, 255, 255, 0.55);
		animation: ring_float 3s ease-in-out infinite;
		transition:
			transform 0.8s cubic-bezier(0.34, 1.56, 0.64, 1),
			border-color 0.8s ease;
	}

	.ring::before {
		content: "";
		position: absolute;
		top: -25px;
		left: 50%;
		width: 20px;
		height: 20px;
		background: linear-gradient(
			135deg,
			#ffffff 0%,
			${props => lighten(props.colormatrix.main, 0.1)} 25%,
			${props => darken(props.colormatrix.main, 0.1)} 55%,
			#ffffff 100%
		);
		border: 1px solid rgba(255, 255, 255, 0.9);
		box-shadow:
			0 0 6px rgba(255, 255, 255, 0.9),
			0 0 10px rgba(143, 211, 244, 0.6);
		transform: translateX(-50%) rotate(45deg);
		z-index: 1;
	}

	.ring::after {
		content: "";
		position: absolute;
		top: -18px;
		left: 50%;
		width: 8px;
		height: 8px;
		background: rgba(255, 255, 255, 0.95);
		border-radius: 1px;
		transform: translateX(-50%) rotate(45deg);
		z-index: 2;
	}

	.ring_left {
		border: 10px solid ${props => props.colormatrix.entrance.envelope_background};
		transform: translateX(-55px) rotate(-8deg);
	}

	.ring_right {
		border: 10px solid ${props => darken(props.colormatrix.entrance.envelope_background, 0.2)};
		transform: translateX(55px) rotate(8deg);
		animation-delay: 0.4s;
	}

	.rings_wrapper.united .ring_left {
		transform: translateX(-22px) rotate(0deg);
		animation: none;
	}

	.rings_wrapper.united .ring_right {
		transform: translateX(22px) rotate(0deg);
		animation: none;
	}

	.sparkles {
		position: absolute;
		width: 100%;
		height: 100%;
		pointer-events: none;
	}

	.sparkle {
		position: absolute;
		opacity: 0;
		color: ${props => darken(props.colormatrix.main, 0.3)};
	}

	.sparkles.burst .sparkle {
		opacity: 1;
		animation: sparkle_burst 0.9s ease-out forwards;
	}

	.sparkle_1 {
		top: 10%;
		left: 20%;
		animation-delay: 0.5s;
	}

	.sparkle_2 {
		top: 15%;
		right: 15%;
		animation-delay: 0.65s;
	}

	.sparkle_3 {
		bottom: 10%;
		left: 30%;
		animation-delay: 0.8s;
	}

	.sparkle_4 {
		bottom: 15%;
		right: 25%;
		animation-delay: 0.95s;
	}

	.tab_continue_container {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 15px;
		margin-top: 10px;

		.tab_continue {
			box-shadow: 0 0 6px 1px ${props => darken(props.colormatrix.main, 0.3)};
			border-radius: 50px;
			padding: 20px;

			svg {
				fill: ${props => darken(props.colormatrix.main, 0.3)};
			}
		}

		.tab_continue_text {
			font-family: var(--poppins), sans-serif;
			font-weight: bold;
			color: ${props => darken(props.colormatrix.main, 0.2)};
		}
	}

	@keyframes flowers_reveal {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}

	@keyframes flower_sway {
		0%,
		100% {
			transform: rotate(-6deg);
		}
		50% {
			transform: rotate(6deg);
		}
	}

	@keyframes ring_float {
		0%,
		100% {
			margin-top: 0;
		}
		50% {
			margin-top: -8px;
		}
	}

	@keyframes sparkle_burst {
		0% {
			opacity: 0;
			transform: scale(0.2);
		}
		40% {
			opacity: 1;
			transform: scale(1.2);
		}
		100% {
			opacity: 0;
			transform: scale(1.6) translateY(-20px);
		}
	}

	@keyframes rings_name_drop {
		from {
			opacity: 0;
			transform: translateY(-14px);
			letter-spacing: 6px;
		}
		to {
			opacity: 1;
			transform: translateY(0);
			letter-spacing: normal;
		}
	}

	@keyframes rings_name_from_start {
		from {
			opacity: 0;
			transform: translateX(-40px) scale(0.9);
			filter: blur(6px);
		}
		to {
			opacity: 1;
			transform: translateX(0) scale(1);
			filter: blur(0);
		}
	}

	@keyframes rings_name_from_end {
		from {
			opacity: 0;
			transform: translateX(40px) scale(0.9);
			filter: blur(6px);
		}
		to {
			opacity: 1;
			transform: translateX(0) scale(1);
			filter: blur(0);
		}
	}

	@keyframes rings_name_pop {
		from {
			opacity: 0;
			transform: scale(0.2) rotate(-20deg);
		}
		to {
			opacity: 1;
			transform: scale(1) rotate(0);
		}
	}

	@keyframes rings_names_glow {
		0%,
		100% {
			text-shadow: none;
		}
		40% {
			text-shadow: 0 0 14px rgba(255, 255, 255, 0.95);
		}
	}
`;
